module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/private-library@2x_f24bed.jpg";